import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

const DOT_COUNT = 6
const DOT_SIZE = 12

/** Loader Dots (Figma 126:24365): 6 chấm, `step` = số chấm đã hoàn thành. */
const LoaderDots = React.forwardRef(({ step = 1, sx, ...props }, ref) => {
  const completed = Math.min(Math.max(Math.round(step), 0), DOT_COUNT)

  return (
    <Box
      ref={ref}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={DOT_COUNT}
      aria-valuenow={completed}
      sx={{ display: 'flex', gap: 'var(--space-8)', ...sx }}
      {...props}
    >
      {Array.from({ length: DOT_COUNT }, (_, index) => (
        <Box
          key={index}
          sx={{
            width: DOT_SIZE,
            height: DOT_SIZE,
            flexShrink: 0,
            borderRadius: '50%',
            bgcolor: index < completed ? 'var(--color-bg-accent)' : 'var(--color-bg-accent-subtle)'
          }}
        />
      ))}
    </Box>
  )
})

LoaderDots.displayName = 'LoaderDots'

LoaderDots.propTypes = {
  step: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]),
  sx: PropTypes.object
}

export default LoaderDots
